var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5L13.0833 12.088C13.0609 12.47 12.8933 12.829 12.6148 13.0915C12.3363 13.354 11.968 13.5001 11.5853 13.5H4.41467C4.03198 13.5001 3.6637 13.354 3.38522 13.0915C3.10674 12.829 2.93912 12.47 2.91667 12.088L2.5 5M6.66667 7.5H9.33333M2.25 5H13.75C14.164 5 14.5 4.664 14.5 4.25V3.25C14.5 2.836 14.164 2.5 13.75 2.5H2.25C1.836 2.5 1.5 2.836 1.5 3.25V4.25C1.5 4.664 1.836 5 2.25 5Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.c7e72066ccda5ce34f19a5dcc685e6a6.svg";
export { ForwardRef as ReactComponent };